import { __zcAsy, __zcFin, __zcFinZ, __zcMkv } from "__zod-compiler-runtime__";
import {safeOptional} from '../../safe-optional'
import * as z from 'zod'

export const AssetSchema = /* @__PURE__ */ (() => {
var __zs=z.lazy(() =>
  z.object({
    fields: z.object({
      description: z.string().optional(),

      file: z.object({
        url: z.string(),
        contentType: z.string().optional(),
        details: safeOptional(
          z.object({
            image: safeOptional(
              z.object({
                width: z.number(),
                height: z.number(),
              }),
            ),
          }),
        ),
      }),
    }),
  }),
);
var __rf=[__zs._zod.innerType.shape["fields"].shape["file"].shape["details"]._zod.def.innerType._zod.def.out._zod.def.transform];
var __bf_2={};
var __rfn_11=__rf[0];
function __vb_3(input){var __bv_4,__bv_5,__bv_6,__bv_7,__bv_8,__bv_9,__bx_10,__bw_12,__bo_13,__bo_14,__bo_15;if(typeof input!=="object"||input===null||Array.isArray(input))return __bf_2;__bv_4=input["fields"];if(typeof __bv_4!=="object"||__bv_4===null||Array.isArray(__bv_4))return __bf_2;__bv_5=__bv_4["description"];if(!((__bv_5===undefined||(typeof __bv_5==="string"))))return __bf_2;__bv_6=__bv_4["file"];if(typeof __bv_6!=="object"||__bv_6===null||Array.isArray(__bv_6))return __bf_2;__bv_7=__bv_6["url"];if(!(typeof __bv_7==="string"))return __bf_2;__bv_8=__bv_6["contentType"];if(!((__bv_8===undefined||(typeof __bv_8==="string"))))return __bf_2;__bv_9=__bv_6["details"];if(__bv_9===undefined){__bw_12=undefined;}else{__bx_10=__rfn_11(__bv_9);if(__bx_10 instanceof Promise)__zcAsy();__bw_12=__bx_10;}__bo_13={"url":__bv_7};if(__bv_8!==undefined||("contentType" in __bv_6)){__bo_13["contentType"]=__bv_8;}if(__bw_12!==undefined||("details" in __bv_6)){__bo_13["details"]=__bw_12;}__bo_14={};if(__bv_5!==undefined||("description" in __bv_4)){__bo_14["description"]=__bv_5;}__bo_14["file"]=__bo_13;__bo_15={"fields":__bo_14};return __bo_15;}
var __rfm_z=__zs.safeParse;
function safeParse_AssetSchema(input){
var __bd_16=__vb_3(input);
if(__bd_16!==__bf_2){return{success:true,data:__bd_16};}
return __zcFinZ(__rfm_z,__zs,input);
}
return __zcMkv(safeParse_AssetSchema,__zs,null,null);
})()

export type Asset = z.infer<typeof AssetSchema>
